import ScopeConstants from "constants/ScopeConstants"

export const ProjectSummaryDirectorScope = {
    key: ScopeConstants.PROJECT_SUMMARY_DIRECTOR,
    selector: (state) => state.projectSummaryDirectorReducer,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Project/GetSumaaryAsDirector",
}